import {Component, EventEmitter, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { Quota, LPGDistService } from 'src/app/lpg-dist/lpg-dist.service';
import { forkJoin } from 'rxjs';
import  momentJ from 'moment-jalaali';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { PgTitleComponent } from '../../../../shared/components/title-bar/title-bar.component';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { PersianDateOnlyPipe } from 'src/app/shared/components/persian-date-only.pipe';

@Component({
  selector: 'app-lpg-quota-entry',
  templateUrl: './lpg-quota-entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialDateRangeComponent,
    MaterialOrganisationSelectorComponent,
    MatIconModule,
    MatSelectModule,
    MaterialPgInputComponent,
    MaterialPgButtonComponent,
    MaterialAutoCompleteComponent,
    PersianDateOnlyPipe
  ],
})
export class LpgQuotaEntryComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  companies: Organisation[] = [];
  sources: Organisation[] = [];
  destinations: Organisation[] = [];
  organisations: Organisation[] = [];
  message?: string;
  source?: Organisation ;
  selectedDate: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  type: string = '';
  value?: number;
  destination?: Organisation;
  selectedQuota?: Quota;
  importedData: Quota[] = [];
  disable: boolean = false;
  edit: boolean = false;
  company: Organisation = Organisation.create();
  typeList: string[] = ['quota', 'sold', 'stored'];

  constructor(private _organisationService: OrganisationService,
              private _lpgDistService: LPGDistService,
              private _activateRoute: ActivatedRoute,
              private _pgMessagesService: PgMessagesService) { }

  ngOnInit() {
    this.title.emit('Quota');
    this._activateRoute.queryParams.subscribe(p => {
      const companyId = p['company'];
      const sourceOrganisationId = p['sourceOrganisationId'];
      const destination = p['destination'];
      this.selectedDate = {
        startDate:  momentJ().subtract('day', 1).startOf('day').toDate(),
        endDate:  momentJ().subtract('day', 1).startOf('day').toDate(),
      };
      forkJoin([
        this._organisationService.get(),
        this._organisationService.getRootOrganisations(),
        this._lpgDistService.getLatestDeterminateQuota(companyId, sourceOrganisationId, destination)
      ])
        .subscribe(data => {
          this.companies  = data[1];
          this.organisations = data[0];
          if(companyId && sourceOrganisationId && destination && data[2]) {
            this.selectedDate = {
              startDate: new Date(data[2].timestamp),
              endDate: new Date(data[2].timestamp)
            };
            this.value = data[2].value;
            this.company = this.organisations.find(o => o.name === companyId) || Organisation.create();
            this.type = 'destination';
            this.destination = this.organisations.find(o => o.name === destination) || Organisation.create();
            this.source = this.organisations.find(o => o.name === sourceOrganisationId) || Organisation.create();
            this.edit = true;
          }
        });
    });

  }

  fetchDate() {
    forkJoin([
      this._organisationService.get(),
      this._organisationService.getRootOrganisations()
    ])
      .subscribe(data => {
        this.companies  = data[1];
        this.organisations = data[0];
      });
  }

  organisationValueFormatter(data: Organisation) {
    return data.nameTranslations['fa'];
  }

  formatOrganisation(organisationId: string) {
    const organisation = this.organisations.find(o => o.name === organisationId);
    return (organisation !== undefined) ? organisation.nameTranslations['fa'] : '';
  }

  formatType(quotaType: string) {
    if (quotaType === 'quota') {
      return 'سهمیه';
    } else if (quotaType === 'sold') {
      return 'فروش';
    } else if (quotaType === 'stored') {
      return 'موجودی';
    } else if (quotaType === 'destination') {
      return 'تعیین مبدا';
    }
    return '';
  }

  sourceFilter() {
    if(!this.edit && this.company) {
      this.source = undefined;
      this.destination = undefined;
      this.value = undefined;
      if (this.type === 'quota') {
        this.sources = this.organisations.filter(o => (o.properties['isLoading'] === true && o.name.includes('niopdc'))
          || (o.properties['isUnloading'] === true && o.name.includes(this.company.name))
        );
      }
      if (this.type === 'destination') {
        this.sources = this.organisations.filter(o => (o.properties['isLoading'] === true && o.name.includes('niopdc')));
        this.destinations = this.organisations.filter(o => o.properties['isUnloading'] === true && o.name.includes(this.company.name));
      }
      if (this.type === 'sold' || this.type === 'stored') {
        this.sources = this.organisations.filter(o => o.properties['isUnloading'] === true && o.name.includes(this.company.name));
      }
    }
  }

  onSubmit() {
    const timestampConst = (this.type === 'quota' || this.type === 'destination') ?
      momentJ(this.selectedDate.startDate).startOf('jMonth').toDate().getTime() :
      momentJ(this.selectedDate.startDate).startOf('day').toDate().getTime();
    if(this.source && this.type && this.value) {
      this.selectedQuota = {
        timestamp: timestampConst,
        quotaType: this.type,
        organisationId: this.company.name,
        sourceOrganisationId: this.source.name,
        destination: (this.type === 'destination' && this.destination) ? this.destination.name : undefined,
        value: +this.value,
        isDeleted: false
      };
      this._lpgDistService.addQuota(this.selectedQuota).subscribe((result: any) => {
        this.importedData.push(result);
        this.message = 'A quota is Imported';
        this._pgMessagesService.publishMessage({
          message: this.message,
          topic: 'New quota',
          level: MessageLevel.Info
        });
      }, () => {
        this.message = 'Error';
        this._pgMessagesService.publishMessage({
          message: this.message,
          topic: 'A quota Insertion Error',
          level: MessageLevel.Error
        });
      });
    }
  }
}
